import React from "react";

const ReportIcon = () => {
  return (
    <svg
      width="25"
      height="24"
      viewBox="0 0 25 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M11.8445 2.32751H5.25C4.69772 2.32751 4.25 2.77523 4.25 3.32751V17.6925C4.25 18.2448 4.69772 18.6925 5.25 18.6925H16.75C17.3023 18.6925 17.75 18.2448 17.75 17.6925V8.05601M11.8445 2.32751L17.75 8.05601M11.8445 2.32751V7.05601C11.8445 7.6083 12.2922 8.05601 12.8445 8.05601H17.75M7.25 21.76H19.75C20.3023 21.76 20.75 21.3123 20.75 20.76V11.26M6.5 11.26H15.5M6.5 7.51001H9.5M6.5 15.01H15.5"
        stroke="#A4A4A4"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export default ReportIcon;
